module.exports = __webpack_public_path__ + "static/media/lounge.ce77fe52.jpeg";